import { ColumnDef } from '@tanstack/react-table'
import i18next from 'i18next'

import { COLUMN_SIZE } from 'components/Table/constants'
import { ParamsKind } from 'features/globalSetup/pages/Prebid/Bidders/types'
import { AdUnitParameter, AdUnitParameters } from 'features/globalSetup/types/adUnitBidder'
import { AdUnitParamInputCell } from '../cells/AdUnitParamInputCell'
import { AdUnitsForTable } from '../types'

type Props = {
  kind: ParamsKind
  params: AdUnitParameters
}

export const createParamsColumns = ({ kind, params }: Props): ColumnDef<AdUnitsForTable> => {
  const t = (path: string): string =>
    i18next.t(
      `features/globalSetup:prebid.bidders.edit.bidParamsAndConnection.adUnitsTable.${path}`,
    ) as string

  const columns = Object.values(params).map(
    (value: AdUnitParameter): ColumnDef<AdUnitsForTable> => {
      const { label, name, required, requiredOff, tooltip } = value

      let header = label
      if (required && !requiredOff) {
        header += '*'
      }

      return {
        accessorKey: `${kind}Params.${name}`,
        cell: context => (
          <AdUnitParamInputCell
            cellContext={context}
            kind={kind}
          />
        ),
        header,
        meta: { tooltip },
        size: COLUMN_SIZE.MD,
      }
    },
  )

  return {
    columns,
    header: t(`params.${kind}`),
  }
}
